import { create } from "zustand";

interface ConfirmationRequest {
  message: string;
  resolve: (confirmed: boolean) => void;
}

interface ConfirmationController {
  request?: ConfirmationRequest;
  open: (message: string, resolve: (confirmed: boolean) => void) => void;
  settle: (confirmed: boolean) => void;
}

export const useConfirmationController = create<ConfirmationController>((set, get) => ({
  request: undefined,
  open: (message, resolve) => {
    get().request?.resolve(false);
    set({ request: { message, resolve } });
  },
  settle: (confirmed) => {
    get().request?.resolve(confirmed);
    set({ request: undefined });
  },
}));
